module.exports = __webpack_public_path__ + "static/media/banner.883a41f6.png";